import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import Icon from "components/Icon";
import PageSection from "components/PageSection";
import Image from "components/Image";
import clsx from "clsx";

const socials = [
  {
    link: "https://www.facebook.com/jedsada.saengow",
    alt: "facebook",
    fileName: "contact/facebook_logo.png",
  },
  {
    link: "https://medium.com/@jedsadasaengow",
    alt: "medium",
    fileName: "contact/medium_logo.png",
  },
  {
    link: "https://www.linkedin.com/in/jedsada-saengow-215047136/",
    alt: "linkedin",
    fileName: "contact/linkedin_logo.png",
  },
  {
    link: "https://github.com/jedsada-jed",
    alt: "github",
    fileName: "contact/github_logo.png",
  },
];

const Contact = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, header, subheader, telephone, email, fullName } = frontmatter;

  return (
    <PageSection className={className} id={anchor}>
      <Row className="justify-content-center">
        <Col lg={3} className="text-center mb-4">
          <ImageMe alt="me" fileName="contact/me.jpeg" />
        </Col>
        <Col lg={6} className="text-center">
          <h1 className="mt-0">{header}</h1>
          <h4 className="mt-4">{fullName}</h4>
          <div className="d-flex justify-content-center">
            <div className="d-flex mt-4 flex-column " style={{ justifyContent: "space-around" }}>
              <a className="d-flex flex-row align-items-center " href={`tel:${telephone}`}>
                <WrapperImageLogo>
                  <Icon iconName="PhoneIcon" size="2x" className="text-muted" />
                </WrapperImageLogo>
                {telephone}
              </a>

              <a className="d-flex flex-row align-items-center" href={`tel:${telephone}`}>
                <WrapperImageLogo>
                  <Icon iconName="EnvelopIcon" size="2x" className="text-muted" />
                </WrapperImageLogo>
                <a className="d-block" href={`mailto:${email}`}>
                  {email}
                </a>
              </a>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-4">
            {socials.map(({ alt, fileName, link }) => {
              return (
                <a key={alt} rel="noreferrer" target="_blank" href={link}>
                  <WrapperImageLogo>
                    <ImageLogo alt={alt} fileName={fileName} />
                  </WrapperImageLogo>
                </a>
              );
            })}
          </div>
        </Col>
        <Empty />
      </Row>
    </PageSection>
  );
};

Contact.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Contact.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Contact;

const WrapperImageLogo = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 4px;
  margin-right: 8px;
  width: 50px;
  margin-bottom: 10px;
  height: 50px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px #ddd;
  background-color: #fff;
`;

const ImageLogo = styled(Image)`
  border-radius: 20px;
  width: 100%;
`;

const ImageMe = styled(Image)`
  border-radius: 10px;
  box-shadow: 0 6px 6px #ddd;
`;

const Empty = styled.div`
  margin-bottom: 300px;
`;
